import { useState, React } from 'react';
import PropTypes from 'prop-types';
import Button from 'sushiweb/Button';
import { TableClickButton, TableClickButtonOverflow } from './styles';
import { DRAFTED } from './constants';
import CreateProgramModal from './CreateProgramModal';
import { MEAL_PLAN } from './CreateProgramModal/ProgramForms/common/Components/constants';
import { programStatusEnum } from '../common/components/constants';

const PlanDetailsBtns = ({ plan }) => {
  const status = programStatusEnum[(plan?.program_status)];
  const [showModal, setShowModal] = useState(false);
  const [canModalClose, setCanModalClose] = useState(true);

  const modalClose = {
    enable: () => setCanModalClose(true),
    disable: () => setCanModalClose(false),
  };

  const closeModal = override => {
    if (canModalClose || override) {
      setShowModal(false);
    }
  };

  return (
    <>
      <CreateProgramModal
        title={MEAL_PLAN}
        showModal={showModal}
        closeModal={closeModal}
        modalClose={modalClose}
        planData={plan}
        planDataFlag={status !== DRAFTED}
      />
      <TableClickButtonOverflow>
        <Button
          size='small'
          appearance='link'
          style={{ margin: '0', padding: '0' }}
          onClick={() => setShowModal(true)}
        >
          <TableClickButton>{plan.name}</TableClickButton>
        </Button>
      </TableClickButtonOverflow>
    </>
  );
};

PlanDetailsBtns.propTypes = {
  plan: PropTypes.objectOf(PropTypes.any),
};

PlanDetailsBtns.defaultProps = {
  plan: {},
};

export default PlanDetailsBtns;
